import React from 'react';
import { ShieldCheck, Zap, Headphones, RefreshCcw } from 'lucide-react';
import { useI18n } from '../context/I18nContext';

export default function TrustBar() {
  const { tr } = useI18n();

  const items = [
    { icon: ShieldCheck, label: tr('trust.ssl', '256-Bit SSL Sertifika') },
    { icon: Zap, label: tr('trust.delivery', 'Anında Teslimat') },
    { icon: Headphones, label: tr('trust.support', '7/24 Teknik Destek') },
    { icon: RefreshCcw, label: tr('trust.updates', 'Ücretsiz Güncellemeler') },
  ];

  return (
    <section className="relative border-y border-[#e4b44e]/15 bg-[#0b0b10]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {items.map(({ icon: Icon, label }) => (
            <div key={label} className="flex items-center gap-3 group">
              <div className="w-11 h-11 flex items-center justify-center rounded-full border border-[#e4b44e]/25 bg-[#e4b44e]/5 group-hover:border-[#e4b44e]/60 transition">
                <Icon className="w-5 h-5 text-[#e4b44e]" strokeWidth={2} />
              </div>
              <div className="text-sm font-semibold text-white/85 tracking-wide">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
